export default class Identifier {
    #element
    #outputElement

    constructor(element) {
        this.#element = element
        this.#outputElement = document.querySelector(element.dataset.gpTarget)

        this.#bindEvents()
    }

    static initAll(selector) {
        Array.from(document.querySelectorAll(selector), (element) => new Identifier(element))
    }

    #bindEvents() {
        this.#element.addEventListener('keyup', () => {
            this.#handleChange()
        })
    }

    generateIdentifier(value) {
        return value.replace(new RegExp('[^a-z0-9-]', 'gi'), '-').toLowerCase()
    }

    #handleChange() {
        let identifier = this.generateIdentifier(this.#element.value)
        let currentIdentifier = this.#outputElement.value

        // Trim the identifier to the current length for comparison
        const compareIdentifier = identifier.slice(0, currentIdentifier.length)

        // When the current identifier is empty or starts with the same characters
        if (currentIdentifier === '' || currentIdentifier.startsWith(compareIdentifier)) {
            this.#outputElement.value = identifier
        }
    }
}
